<template>
  <v-card class="pa-4">
    <v-card-title
      class="headline text-center d-block full-width"
    >
      Päivitys saatavilla
    </v-card-title>

    <v-card-text
      class="text-center my-2"
    >
      Sinun tulee päivittää sivusto voidaksesi jatkaa käyttöä
    </v-card-text>

    <v-card-actions>
      <v-btn
        :disabled="refreshing"
        :loading="refreshing"
        depressed
        block
        large
        style="height: 48px;"
        color="primary"
        @click="refresh"
      >
        Päivitä
        <v-icon
          right
        >
          refresh
        </v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    refreshing: false,
  }),

  computed: {
    ...mapGetters({
      reg: 'sw/reg',
    }),
  },

  methods: {
    refresh() {
      this.refreshing = true;

      /**
       * this.reg.waiting is the new, updated service worker that is waiting
       * to take over.
       *
       * To handle things smoothly, we'll need to add an event
       * listener to detect the controllerchange event, and only when the
       * event has fired, we can reload the page safely.
       *
       * Reloading the page before the controllerchange event has fired may
       * cause users to end up in a refresh loop.
       */
      if (this.reg.waiting && 'postMessage' in this.reg.waiting) {
        let refreshing;

        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });

        this.reg.waiting.postMessage({ action: 'skip-waiting' });
      } else {
        /**
         * The this.reg.waiting may be null or undefined if some other page or
         * tab has already installed the incoming service worker. Reloading
         * the page here is safe.
         */
        window.location.reload();
      }
    },
  },
};
</script>
